import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sentencecase',
  standalone: false,
})
export class SentenceCasePipe implements PipeTransform {
  transform(value: string) {
    const firstChar = value && value.length > 0 ? value.charAt(0) : '';
    const restChars = value.substring(1);

    return firstChar?.length > 0
      ? firstChar.toUpperCase() + restChars.toLowerCase()
      : '';
  }
}
